module.exports = __webpack_public_path__ + "img/Las-Canastas.1c73704a.jpg";